let collectionPagination = null;

function loadMore() {
  if (collectionPagination) {
    collectionPagination.observer?.disconnect();
    collectionPagination.cleanup?.();
    collectionPagination.request?.abort();
  }

  const root = document.getElementById('ProductGridContainer');
  if (root) window.huedraCollection?.restore(root);
  const trigger = root?.querySelector('.js-infinite-scroll, .js-load-more');
  const grid = root?.querySelector('.load-more-grid');
  if (!trigger || !grid) {
    collectionPagination = null;
    return;
  }

  const state = { root, trigger, grid, observer: null, request: null, loading: false, fetchMs: 700, startedAt: 0 };
  collectionPagination = state;
  const isCurrent = () => state === collectionPagination && grid === root.querySelector('.load-more-grid');

  const showPaginationLinks = () => {
    state.observer?.disconnect();
    trigger.remove();
    root.querySelector('.js-hidden')?.classList.remove('js-hidden');
  };

  const loadNextPage = () => {
    if (!isCurrent() || state.loading) return;
    const nextInput = root.querySelector('input[data-next-url]');
    const currentInput = root.querySelector('input[data-current-page]');
    const currentPage = Number(currentInput?.value);
    if (!nextInput?.value || !Number.isInteger(currentPage)) {
      showPaginationLinks();
      return;
    }

    // Preserve the collection, locale, sort order and filters from Shopify's next URL.
    const url = new URL(nextInput.value, window.location.href);
    if (grid.dataset.id) url.searchParams.set('section_id', grid.dataset.id);
    url.searchParams.set('view', 'huedra-pagination');
    state.loading = true;
    state.startedAt = performance.now();
    state.observer?.disconnect();
    trigger.setAttribute('disabled', '');
    trigger.classList.add('loading');

    state.request = $.ajax({
      url: url.href,
      type: 'GET',
      dataType: 'html',
      timeout: 15000,
      success(responseHTML) {
        if (!isCurrent()) return;
        const response = new DOMParser().parseFromString(responseHTML, 'text/html');
        const nextGrid = response.querySelector('#ProductGridContainer .load-more-grid');
        if (!nextGrid || !nextGrid.children.length) {
          showPaginationLinks();
          return;
        }

        // Parse once and move only cards. Avoid rerunning scripts on every appended page.
        nextGrid.querySelectorAll('script').forEach((script) => {
          if (!script.type || /(?:java|ecma)script/.test(script.type)) script.remove();
        });
        const fragment = document.createDocumentFragment();
        while (nextGrid.firstChild) fragment.appendChild(nextGrid.firstChild);
        grid.appendChild(fragment);
        currentInput.value = String(currentPage + 1);
        currentInput.dataset.currentPage = currentInput.value;

        // Keep the fallback links aligned with the last successfully appended page.
        const fallback = root.querySelector('.js-hidden');
        const nextFallback = response.querySelector('#ProductGridContainer .js-hidden');
        if (fallback && nextFallback) {
          // Fallback navigation must open the full collection, never the fragment view.
          const originalView = new URL(window.location.href).searchParams.get('view');
          nextFallback.querySelectorAll('a[href]').forEach(link => {
            const href = new URL(link.getAttribute('href'), window.location.href);
            href.searchParams.delete('section_id');
            href.searchParams.delete('view');
            if (originalView) href.searchParams.set('view', originalView);
            link.setAttribute('href', href.pathname + href.search + href.hash);
          });
          fallback.innerHTML = nextFallback.innerHTML;
        }
        const followingUrl = response.querySelector('#ProductGridContainer input[data-next-url]')?.value;
        nextInput.value = followingUrl || '';
        nextInput.dataset.nextUrl = nextInput.value;
        if (!followingUrl) {
          state.observer?.disconnect();
          trigger.remove();
        }
        if (typeof colorSwatches === 'function') colorSwatches();
      },
      error(_request, status) {
        if (status !== 'abort' && isCurrent()) showPaginationLinks();
      },
      complete() {
        if (!isCurrent()) return;
        state.request = null;
        state.fetchMs = state.fetchMs * 0.5 + (performance.now() - state.startedAt) * 0.5;
        state.loading = false;
        if (trigger.isConnected) {
          trigger.removeAttribute('disabled');
          trigger.classList.remove('loading');
          state.observer?.observe(trigger);
        }
      },
    });
  };

  if (trigger.classList.contains('js-infinite-scroll') && 'IntersectionObserver' in window) {
    let previousY = scrollY, previousTime = performance.now(), velocity = 0;
    let lastUpdate = 0, currentMargin = 1800;
    const observe = margin => {
      state.observer?.disconnect();
      state.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) loadNextPage();
      }, {rootMargin: `0px 0px ${margin}px 0px`});
      if (trigger.isConnected && !state.loading) state.observer.observe(trigger);
    };
    const onScroll = () => {
      const now = performance.now();
      const elapsed = now - previousTime;
      if (elapsed > 0) velocity = elapsed > 500 ? 0 : velocity * 0.6 + Math.max(0, scrollY - previousY) / elapsed * 0.4;
      previousY = scrollY; previousTime = now;
      if (now-lastUpdate<500 || state.loading || !isCurrent()) return;
      lastUpdate = now;
      const saveData = navigator.connection?.saveData;
      const target = saveData ? 1000 : Math.min(4800, Math.max(1800, Math.ceil((velocity * (state.fetchMs + 700) + innerHeight) / 400) * 400));
      if (Math.abs(target-currentMargin)>=400){currentMargin=target;observe(target);}
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    state.cleanup = () => window.removeEventListener('scroll', onScroll);
    observe(currentMargin);
  } else if (trigger.classList.contains('js-load-more')) {
    trigger.onclick = loadNextPage;
  } else {
    showPaginationLinks();
  }
}

loadMore();
